/**
 * AgendaLembretesPage — domínio "Agenda & lembretes" (`/admin/agenda`), Admin
 * Hub T10. Quarta das 5 páginas de domínio (T7-T11).
 *
 * `canManage` (`tenant-config-manage`) é resolvida AQUI, uma vez, e passada
 * aos 2 tabs — mesmo contrato que `OrganizacaoPage`/`IaCondutaPage`/
 * `AtendimentoFilaPage` já usam (medido em context.md).
 *
 *   - `#agenda-nativa` (`SchedulingTab`) — dirty-diff real, registra na
 *     `StickySaveBar` via `useSectionSave`. Migrado nesta task: trocou
 *     `update.mutate` por `update.mutateAsync` e o `<header>` próprio saiu,
 *     mesmo movimento que T7-T9 já fizeram.
 *   - `#lembretes` (`RemindersTab`) — mesmo tratamento; NÃO se registra na
 *     barra quando ligado sem nenhuma antecedência (estado incompleto que o
 *     backend rejeitaria).
 *
 * ★ RULING do coordenador — o plano do dispatch (T10) pedia construir
 * "lembretes dependentes de agenda desligada aparecem desabilitados COM
 * explicação", atribuindo isso à prancha 07. MEDIDO: a prancha 07 não fixa
 * nada disso (nenhuma ocorrência de "desabilit"/"desligad"/"depende"/
 * "inativ"/"requer"/"precisa" no texto inteiro — vide context.md). E
 * construir essa dependência seria um DEFEITO: a própria prancha diz que a
 * agenda nativa serve tenants "SEM ERP de agendamento" — tenant COM ERP
 * agenda por lá e CONTINUA precisando de lembretes (`RemindersTab` é
 * agnóstico à origem do agendamento, próprio docblock). Em vez de construir
 * o acoplamento, este arquivo carrega o teste de INDEPENDÊNCIA — a prova de
 * que ninguém adiciona esse acoplamento por engano no futuro.
 *
 * Fidelidade — prancha "07 Dominio Agenda e lembretes.dc.html", variante 2a.
 * Mesma divergência já declarada em T7/T8/T9: a busca "Buscar nesta
 * página…" do cabeçalho da prancha não existe (layout de `DomainPage`, T4,
 * fora do escopo desta task). Nenhuma outra divergência de conteúdo
 * encontrada — `SchedulingTab`/`RemindersTab` já expõem exatamente os campos
 * que a prancha desenha para estas duas seções.
 */
import { useCapability } from '../../../../hooks/use-capability';
import { RemindersTab } from '../../config-tenant/RemindersTab';
import { SchedulingTab } from '../../config-tenant/SchedulingTab';
import { CONFIG_CATALOG } from '../catalog';
import { DomainPage } from '../DomainPage';
import { DomainSection } from '../DomainSection';
import { DomainSaveProvider } from '../save-bar-context';
import { StickySaveBar } from '../StickySaveBar';

function item(id: string) {
  const found = CONFIG_CATALOG.find((i) => i.id === id);
  if (found === undefined) throw new Error(`Item de catálogo ausente: ${id}`);
  return found;
}

export function AgendaLembretesPage(): JSX.Element {
  const canManage = useCapability('tenant-config-manage');

  return (
    <DomainSaveProvider>
      <DomainPage dominio="agenda">
        <DomainSection item={item('agenda-nativa')}>
          <SchedulingTab canManage={canManage} />
        </DomainSection>
        <DomainSection item={item('lembretes')}>
          <RemindersTab canManage={canManage} />
        </DomainSection>
        <StickySaveBar />
      </DomainPage>
    </DomainSaveProvider>
  );
}
